import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import FormInput from '../../../../library/form/components/FormInput';
import FormTitle from '../../../../library/form/components/FormTitle'
import FormLabel from '../../../../library/form/components/FormLabel'
import FormCheckbox from '../../../../library/form/components/FormCheckbox';

const CategoryDetailSH = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ actionParam:{showModeID: 'sh'}, formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ width: '350px'}}
            formTitle={<FormTitle formObject={formObject} value='Category Details' />}
            formObject={formObject} >
            <div>
                <div className="uiEditableContent">
                    <div className="uiRow uiSpacer15">
                        <span className="uiLbl" >
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cdName" }} value="Category Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" autofocus action={{ InputType: "input", paramName: "cdName" }} />
                    </div>
                    <div className="uiRow uiSpacer15">
                        <span className="uiLbl" >
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cdNickName" }} value="Nick Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "cdNickName" }} />
                    </div>
                    <div className="uiRow uiSpacer15">
                        <span className="uiLbl" >
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cdCode" }} value="Category Code" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "cdCode" }} />
                    </div>
                    <div className="uiRow uiSpacer15">
                        <span className="uiLbl" >
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cdParent" }} value="Parent" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                            action={{ InputType: "ac", paramName: "cdParent", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                    </div>
                    <div className="uiRow uiSpacer15">
                        <span className="uiLbl" >
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cdGroupCode" }} value="Group Code" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "cdGroupCode" }} />
                    </div>
                    <div className="uiRow uiSpacer15">
                        <span className="uiLbl" >
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cdStyleAttribute" }} value="Style Attribute" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "cdStyleAttribute" }} />
                    </div>
                    <div className="uiRow uiSpacer15">
                        <span className="uiLbl" >
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cdSortIndex" }} value="Sort No" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "cdSortIndex" }} />
                    </div>
                    <div className="uiRow uiSpacer15">
                        <span className="uiLbl" >
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cdActive" }} value="Is Active" />
                        </span>
                        <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "cdActive" }} />
                    </div>
                </div>
            </div >
        </FormDialog>
    )
}

export default withView(CategoryDetailSH, "catDetail", "");